import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=af87194e"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af87194e')) {
      api.createRecord('af87194e', component.options)
    } else {
      api.reload('af87194e', component.options)
    }
    module.hot.accept("./LoadingOverlay.vue?vue&type=template&id=af87194e", function () {
      api.rerender('af87194e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth2/shared/LoadingOverlay.vue"
export default component.exports